import React, { useState, useEffect } from "react";
import { useLocation, Link, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Menu, Tag, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
// Navigation
import Navigation from "../../../navigation";

const MenuItem = (props) => {
  const { onClose, collapsed } = props;
  const { user } = useSelector((state) => state.auth);
  const [navigation, setNavigation] = useState([]);
  const { i18n } = useTranslation();
  const history = useHistory();

  // Navigation
  const { superAdminNav, marketingAdminNav, adminNav } = Navigation();

  useEffect(() => {
    if (user?.role === "superadmin") {
      setNavigation(superAdminNav);
    } else if (user?.role === "marketing") {
      setNavigation(marketingAdminNav);
    } else if (user?.role === "admin") {
      setNavigation(adminNav);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.role, i18n.language]);

  // Location
  const location = useLocation();
  const { pathname } = location;

  const splitLocation = pathname.split("/");

  const menuItem =
    navigation &&
    navigation?.map((item, index) => {
      let itemNavLink;

      // Determine if navLink is a function or string
      const isNavLinkFunction = typeof item?.navLink === "function";

      // If user is superadmin or navLink is a string
      if (user?.role === "superadmin" || user?.role === "marketing" || !isNavLinkFunction) {
        itemNavLink = typeof item?.navLink === "string" ? item?.navLink?.split("/") : [];
      } else if (user?.role === "admin" && isNavLinkFunction) {
        // Call the function with workspaceId to get the URL string
        const navLink = item?.navLink?.(user?.workspaceId);
        itemNavLink = navLink?.split("/");
      }

      // Create an enhanced icon with FIXED sizing - same for both collapsed/expanded
      const enhancedIcon = item.icon
        ? React.cloneElement(item.icon, {
            style: {
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "24px",
              height: "24px",
              minWidth: "24px",
              flexShrink: 0,
              overflow: "visible",
            },
            className: "menu-icon",
          })
        : null;

      const navLinkPath = isNavLinkFunction
        ? item.navLink(user?.workspaceId)
        : item.navLink;

      // Determine if this menu item is selected
      const isSelected =
        splitLocation[splitLocation?.length - 2] +
          "/" +
          splitLocation[splitLocation?.length - 1] ===
        itemNavLink[itemNavLink?.length - 2] +
          "/" +
          itemNavLink[itemNavLink?.length - 1];

      if (collapsed) {
        // For collapsed sidebar, use icon prop (not children) so it stays visible
        return (
          <Tooltip
            title={item.title}
            placement="right"
            overlayClassName="menu-tooltip"
            mouseEnterDelay={0.1}
            mouseLeaveDelay={0.1}
            trigger={["hover"]}
            key={index}
          >
            <Menu.Item
              key={index}
              icon={enhancedIcon}
              onClick={() => {
                onClose();
                window.location.href = navLinkPath;
              }}
              className={`${
                isSelected
                  ? "ant-menu-item-selected"
                  : "ant-menu-item-selected-in-active"
              } collapsed-menu-item ${item.tourClass || ""}`}
              style={{
                overflowX: "hidden",
                whiteSpace: "nowrap",
                height: "40px",
                display: "flex",
                alignItems: "center",
              }}
            />
          </Tooltip>
        );
      }

      // For expanded sidebar, use normal rendering
      return (
        <Menu.Item
          key={index}
          icon={enhancedIcon}
          onClick={() => {
            onClose();
            history.push(navLinkPath);
          }}
          className={`${
            itemNavLink &&
            splitLocation[splitLocation?.length - 2] +
              "/" +
              splitLocation[splitLocation?.length - 1] ===
              itemNavLink[itemNavLink?.length - 2] +
                "/" +
                itemNavLink[itemNavLink?.length - 1]
              ? "ant-menu-item-selected"
              : "ant-menu-item-selected-in-active"
          } ${item.tourClass || ""}`}
          style={
            item.tag
              ? { pointerEvents: "none" }
              : {
                  overflowX: "hidden",
                  whiteSpace: "nowrap",
                  textAlign: "left",
                }
          }
        >
          {item.tag ? (
            <p
              className="hp-d-flex hp-align-items-center hp-d-flex-between"
              style={{ pointerEvents: "none" }}
            >
              <span>{item.title}</span>
              <Tag
                className="hp-mr-0 hp-border-none hp-text-color-black-100 hp-bg-success-3 hp-border-radius-full hp-px-8"
                style={{ marginRight: -14 }}
              >
                {item.tag}
              </Tag>
            </p>
          ) : (
            <Link to={navLinkPath || "#"} style={{ position: "relative", top: "2px" }}>
              {item.title}
            </Link>
          )}
        </Menu.Item>
      );
    });

  return (
    menuItem && (
      <Menu
        mode="inline"
        defaultOpenKeys={[
          splitLocation?.length === 5
            ? splitLocation[splitLocation?.length - 3]
            : null,
          splitLocation[splitLocation?.length - 2],
        ]}
        theme={"light"}
        className={collapsed ? "collapsed-menu" : "expanded-menu"}
        style={{
          width: "100%",
          overflowX: "hidden",
        }}
      >
        {menuItem}
      </Menu>
    )
  );
};

export default MenuItem;
